//LOGIN
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const REFRESHTOKEN = "REFRESHTOKEN";

//USER
export const EDIT_USER_DETAILS = "EDIT_USER_DETAILS";
export const EDIT_USER_PROFILE = "EDIT_USER_PROFILE";
export const LOAD_PROFILES = "LOAD_PROFILES";
export const ADD_USER = "ADD_USER";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_PASSWORD = "EDIT_USER_PASSWORD";
export const REMOVE_USER = "REMOVE_USER";

//ALERT
export const ADD_ALERT = "ADD_ALERT";

//LOADING
export const TOGGLE_LOADING = "TOGGLE_LOADING";

//HOSTS
export const CREATE_HOST = "CREATE_HOST";
export const EDIT_HOST = "EDIT_HOST";
export const REMOVE_HOST = "REMOVE_HOST";
export const LOAD_HOSTS = "LOAD_HOSTS";
export const REMOVE_HOSTS = "REMOVE_HOSTS";

//KEYS
export const CREATE_KEY = "CREATE_KEY";
export const EDIT_KEY = "EDIT_KEY";
export const REMOVE_KEY = "REMOVE_KEY";
export const LOAD_KEYS = "LOAD_KEYS";
export const REMOVE_KEYS = "REMOVE_KEYS";

//LOG
export const REMOVE_LOG = "REMOVE_LOG";
export const REMOVE_LOGS = "REMOVE_LOGS";
export const LOAD_LOGS = "LOAD_LOGS";

//RC
export const CREATE_RC = "CREATE_RC";
export const EDIT_RC = "EDIT_RC";
export const REMOVE_RC = "REMOVE_RC";
export const LOAD_RC = "LOAD_RC";
export const REMOVE_RCS = "REMOVE_RCS";

//RULESBYAMOUNT
export const CREATE_RULESBYAMOUNT = "CREATE_RULESBYAMOUNT";
export const EDIT_RULESBYAMOUNT = "EDIT_RULESBYAMOUNT";
export const REMOVE_RULESBYAMOUNT = "REMOVE_RULESBYAMOUNT";
export const LOAD_RULESBYAMOUNT = "LOAD_RULESBYAMOUNT";
export const REMOVE_RULESBYAMOUNTS = "REMOVE_RULESBYAMOUNTS";

//TERMINAL
export const CREATE_TERMINAL = "CREATE_TERMINAL";
export const EDIT_TERMINAL = "EDIT_TERMINAL";
export const REMOVE_TERMINAL = "REMOVE_TERMINAL";
export const LOAD_TERMINAL = "LOAD_TERMINAL";
export const REMOVE_TERMINALS = "REMOVE_TERMINALS";

//TRANSACTION
export const REMOVE_TRANSACTION = "REMOVE_TRANSACTION";
export const LOAD_TRANSACTIONS = "LOAD_TRANSACTIONS";
export const SET_TRANSACTIONS = "SET_TRANSACTIONS";
export const REMOVE_TRANSACTIONS = "REMOVE_TRANSACTIONS";

//PROTOCOLS
export const CREATE_PROTOCOL = "CREATE_PROTOCOL";
export const EDIT_PROTOCOL = "EDIT_PROTOCOL";
export const REMOVE_PROTOCOL = "REMOVE_PROTOCOL";
export const LOAD_PROTOCOL = "LOAD_PROTOCOL";
export const REMOVE_PROTOCOLS = "REMOVE_PROTOCOLS";
